var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('article',{staticClass:"gisViewer-cont"},[_c('div',{ref:"viewerGISDom",staticClass:"viewerGIS_main",attrs:{"id":"viewerGISDom"}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.setting.showMask),expression:"setting.showMask"}],ref:"viewerMaskDom",staticClass:"mask"})])
}
var staticRenderFns = []

export { render, staticRenderFns }